import CouponStateLabel from './coupon-state-label-view'

export default CouponStateLabel
